/**
 * Coss Product Card interactions
 * - Wishlist toggle (localStorage, capture phase)
 * - "Select Shade" → variant picker modal (multi-variant)
 * - Add-to-cart: modal ATC (multi-variant) + xo-cart-add (single-variant)
 * - Toast notifications (ATC green, wishlist pink)
 * - Cart count sync after every add
 */
(function () {
  'use strict';

  /* ─── Wishlist storage ─────────────────────────────── */
  var STORE_KEY = 'cs_wishlist';
  function getWishlisted() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlisted(ids) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function toggleWishlist(id) {
    var ids = getWishlisted();
    var idx = ids.indexOf(String(id));
    if (idx === -1) { ids.push(String(id)); saveWishlisted(ids); return true; }
    ids.splice(idx, 1); saveWishlisted(ids); return false;
  }

  /* ─── Restore wishlist state on load ──────────────── */
  function initWishlistState() {
    var ids = getWishlisted();
    if (!ids.length) return;
    ids.forEach(function (id) {
      document.querySelectorAll('[data-product-id="' + id + '"].cs-pcard__wish-btn').forEach(function (btn) {
        btn.classList.add('cs-pcard__wish-btn--wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      });
    });
  }

  /* ─── Toast ────────────────────────────────────────── */
  function showToast(msg, type) {
    var prev = document.querySelector('.cs-toast');
    if (prev) prev.remove();
    var el = document.createElement('div');
    el.className = 'cs-toast' + (type === 'wishlist' ? ' cs-toast--wishlist' : '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('cs-toast--visible'); });
    });
    setTimeout(function () {
      el.classList.remove('cs-toast--visible');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
    }, 3000);
  }

  /* ─── Dedup guard — prevents double-toast within 1.5 s ── */
  var _lastAtcToast = 0;
  function showAtcToast() {
    var now = Date.now();
    if (now - _lastAtcToast < 1500) return;
    _lastAtcToast = now;
    showToast('✓ Added to your bag!');
  }

  /* ─── Money formatter ──────────────────────────────── */
  function fmtMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  /* ─── Cart count sync ───────────────────────────────── */
  function updateCartCount() {
    _fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('xo-cart-size').forEach(function (el) { el.textContent = count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  /* ─── Force XO mini cart drawer to re-render via Section Rendering API ── */
  /* Called after modal ATC since our direct _fetch bypasses XO's cart-add handler */
  function refreshXoCartMini() {
    fetch('/?sections=xo-cart-mini')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['xo-cart-mini'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        /* Full swap: replaces entire xo-cart-mini so empty→items transition works */
        var liveCart = document.querySelector('xo-cart-mini');
        var newCart  = doc.querySelector('xo-cart-mini');
        if (liveCart && newCart) {
          liveCart.innerHTML = newCart.innerHTML;
          /* Size + relocate upsell after DOM settles */
          requestAnimationFrame(function () {
            relocateCartUpsell();
            sizeCartItems();
          });
          return;
        }
        /* Fallback: patch only xo-cart-will-change elements */
        doc.querySelectorAll('xo-cart-will-change[xo-unique-id]').forEach(function (newEl) {
          var uid = newEl.getAttribute('xo-unique-id');
          var liveEl = document.querySelector('xo-cart-will-change[xo-unique-id="' + uid + '"]');
          if (liveEl) liveEl.innerHTML = newEl.innerHTML;
        });
        requestAnimationFrame(function () {
          relocateCartUpsell();
          sizeCartItems();
        });
      })
      .catch(function () {});
  }

  /* ─── Relocate cart upsell from footer → scroll body (DOM surgery fallback) ── */
  /* The Liquid template has been fixed, but if the server returns old HTML where
     the carousel is inside .xo-modal-content-style1__footer, this moves it out. */
  function relocateCartUpsell() {
    var footer = document.querySelector('.xo-modal-content-style1__footer');
    var body   = document.querySelector('xo-cart-scroll .xo-modal-content-style1__content');
    if (!footer || !body) return;
    var footerTitle    = footer.querySelector('.title-collection-cart');
    var footerCarousel = footer.querySelector('xo-carousel');
    /* Nothing to move — new template already places upsell in body */
    if (!footerTitle && !footerCarousel) return;
    /* Don't duplicate if we already moved it */
    if (body.querySelector('.cs-cart-upsell')) return;
    var wrap = document.createElement('div');
    wrap.className = 'cs-cart-upsell';
    if (footerTitle)    wrap.appendChild(footerTitle);
    if (footerCarousel) wrap.appendChild(footerCarousel);
    body.appendChild(wrap);
    sizeCartItems();
  }

  /* ─── Push "You may also like" below the cart scroll fold ── */
  /* Measures the actual scroll area height and sets items min-height
     so the upsell section always starts just off-screen. */
  function sizeCartItems() {
    var scroll = document.querySelector('xo-cart-scroll');
    if (!scroll) return;
    var items  = scroll.querySelector('.xo-cart-mini-content__successfully');
    var upsell = scroll.querySelector('.cs-cart-upsell');
    if (!items) return;
    /* Reset first so we measure natural height */
    items.style.minHeight = '';
    if (!upsell) return;
    var scrollH  = scroll.clientHeight;
    var upsellH  = upsell.offsetHeight + 24; /* 24 = margin + padding */
    var itemsH   = items.offsetHeight;
    /* Only adjust when upsell is visible without scrolling */
    if (itemsH + upsellH <= scrollH) {
      items.style.minHeight = (scrollH - upsellH) + 'px';
    }
  }

  /* ─── Our own ATC helpers (independent of xo-cart-add) ── */

  /* Try to open the cart mini/drawer via theme events */
  function openCartDrawer() {
    if (window._csCheckoutInProgress) return; /* checkout's own /cart/add call — don't reopen a closed drawer */
    if (window.xoModal && typeof window.xoModal.open === 'function') {
      window.xoModal.open('cart');
      setTimeout(function () { relocateCartUpsell(); sizeCartItems(); }, 350);
      return;
    }
    ['xo-cart:open', 'xo:cart:open', 'cart:open', 'theme:cart:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    var trigger = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (trigger) trigger.click();
    setTimeout(function () { relocateCartUpsell(); sizeCartItems(); }, 350);
  }

  /* ═══════════════════════════════════════════════════
     VARIANT PICKER MODAL
     ═══════════════════════════════════════════════════ */
  var modal = null;
  var modalOverlay = null;
  var modalSwatchWrap = null;
  var modalVname = null;
  var modalPrice = null;
  var modalCompare = null;
  var modalBadge = null;
  var modalViewBtn = null;
  var modalAtcBtn = null;
  var currentProductUrl = null;
  var selectedVariantId = null;
  var currentVariants = [];
  var currentProductTitle = '';

  function buildModal() {
    if (modal) return;

    modalOverlay = document.createElement('div');
    modalOverlay.className = 'cs-vmodal-overlay';
    modalOverlay.setAttribute('hidden', '');
    modalOverlay.setAttribute('role', 'dialog');
    modalOverlay.setAttribute('aria-modal', 'true');

    modal = document.createElement('div');
    modal.className = 'cs-vmodal';
    modal.innerHTML =
      '<button class="cs-vmodal__close" aria-label="Close">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="cs-vmodal__swatches"></div>' +
      '<div class="cs-vmodal__info">' +
        '<div class="cs-vmodal__vname"></div>' +
        '<div class="cs-vmodal__price-row">' +
          '<span class="cs-vmodal__price"></span>' +
          '<span class="cs-vmodal__compare" hidden></span>' +
          '<span class="cs-vmodal__badge" hidden></span>' +
        '</div>' +
      '</div>' +
      '<div class="cs-vmodal__actions">' +
        '<a class="cs-vmodal__view-btn" href="#">View Details</a>' +
        '<button class="cs-vmodal__atc-btn" type="button">Add to Bag</button>' +
      '</div>';

    modalSwatchWrap = modal.querySelector('.cs-vmodal__swatches');
    modalVname      = modal.querySelector('.cs-vmodal__vname');
    modalPrice      = modal.querySelector('.cs-vmodal__price');
    modalCompare    = modal.querySelector('.cs-vmodal__compare');
    modalBadge      = modal.querySelector('.cs-vmodal__badge');
    modalViewBtn    = modal.querySelector('.cs-vmodal__view-btn');
    modalAtcBtn     = modal.querySelector('.cs-vmodal__atc-btn');

    modal.querySelector('.cs-vmodal__close').addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modalOverlay.hasAttribute('hidden')) closeModal();
    });

    modalAtcBtn.addEventListener('click', function () {
      if (!selectedVariantId || modalAtcBtn.disabled) return;
      modalAtcBtn.disabled = true;
      _fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(selectedVariantId, 10), quantity: 1 })
      }).then(function (res) {
        if (res.ok) {
          var selV = currentVariants.filter(function (v) { return String(v.id) === String(selectedVariantId); })[0] || {};
          pushGA4AddToCart([{
            item_id: selV.sku || '',
            item_name: currentProductTitle,
            item_variant: selV.title || '',
            price: (selV.price || 0) / 100,
            quantity: 1
          }]);
          showAtcToast();
          updateCartCount();
          refreshXoCartMini();
          closeModal();
          openCartDrawer();
        } else {
          modalAtcBtn.disabled = false;
          updateCartCount();
        }
      }, function () {
        modalAtcBtn.disabled = false;
        updateCartCount();
      });
    });

    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);
  }

  function openModal(variants, productTitle, productUrl) {
    buildModal();
    currentProductUrl = productUrl;
    currentVariants = variants || [];
    currentProductTitle = productTitle || '';

    /* Render swatches */
    modalSwatchWrap.innerHTML = '';
    variants.forEach(function (mv, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-vmodal__swatch' + (i === 0 ? ' cs-vmodal__swatch--active' : '') + (!mv.available ? ' cs-vmodal__swatch--unavail' : '');
      btn.title = mv.title;
      btn.setAttribute('aria-label', mv.title);
      btn.dataset.variantId = mv.id;
      btn.dataset.price = mv.price;
      btn.dataset.compareAt = mv.compareAt || 0;
      btn.dataset.title = mv.title;
      btn.dataset.available = mv.available;

      if (mv.color) {
        /* Hex / CSS color from Shopify swatch API */
        btn.style.backgroundColor = mv.color;
        btn.setAttribute('aria-label', mv.title);
      } else if (mv.img) {
        var img = document.createElement('img');
        img.src = mv.img;
        img.alt = mv.title;
        img.loading = 'lazy';
        btn.appendChild(img);
      } else {
        btn.textContent = mv.title.charAt(0).toUpperCase();
      }

      btn.addEventListener('click', function () {
        modalSwatchWrap.querySelectorAll('.cs-vmodal__swatch').forEach(function (s) {
          s.classList.remove('cs-vmodal__swatch--active');
        });
        btn.classList.add('cs-vmodal__swatch--active');
        selectVariant(mv);
      });

      modalSwatchWrap.appendChild(btn);
    });

    /* Select first variant */
    if (variants.length) selectVariant(variants[0]);

    modalOverlay.removeAttribute('hidden');
    window.csScrollLock && csScrollLock.lock('vmodal');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modalOverlay.classList.add('cs-vmodal-overlay--open'); });
    });
  }

  function selectVariant(mv) {
    selectedVariantId = mv.id;
    modalVname.textContent = mv.title;
    modalPrice.textContent = fmtMoney(mv.price);

    var compareAt = mv.compareAt || mv['compareAt'] || 0;
    if (compareAt > mv.price) {
      var pct = Math.round((compareAt - mv.price) * 100 / compareAt);
      modalCompare.textContent = fmtMoney(compareAt);
      modalCompare.removeAttribute('hidden');
      modalBadge.textContent = pct + '% Off';
      modalBadge.removeAttribute('hidden');
    } else {
      modalCompare.setAttribute('hidden', '');
      modalBadge.setAttribute('hidden', '');
    }

    var url = currentProductUrl + '?variant=' + mv.id;
    modalViewBtn.href = url;
    modalAtcBtn.disabled = !mv.available;
  }

  function closeModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.remove('cs-vmodal-overlay--open');
    window.csScrollLock && csScrollLock.unlock('vmodal');
    setTimeout(function () { modalOverlay.setAttribute('hidden', ''); }, 260);
  }

  /* ─── "Select Shade" button click ─────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-select-variant]');
    if (!btn) return;
    var raw = btn.getAttribute('data-variants') || '[]';
    var variants;
    try { variants = JSON.parse(raw); } catch (_) { variants = []; }
    var title = btn.getAttribute('data-product-title') || '';
    var url   = btn.getAttribute('data-product-url') || '#';
    openModal(variants, title, url);
  }, true);

  /* ─── Wishlist click ───────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cs-pcard__wish-btn');
    if (!btn) return;
    var productId = btn.getAttribute('data-product-id');
    var added = toggleWishlist(productId);
    btn.classList.toggle('cs-pcard__wish-btn--wishlisted', added);
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
    showToast(added ? '❤ Added to Wishlist' : 'Removed from Wishlist', 'wishlist');
  }, true);

  /* ─── GA4 add_to_cart helper ── */
  function pushGA4AddToCart(items) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'INR',
        value: items.reduce(function (s, it) { return s + (it.price || 0) * (it.quantity || 1); }, 0),
        items: items
      }
    });
  }

  /* ─── Our own ATC: intercepts card button, bypasses xo-cart-add entirely ── */
  var _fetch = window.fetch;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cs-pcard__atc-btn[data-cs-vid]');
    if (!btn || btn.dataset.csBusy) return;

    var vid = btn.getAttribute('data-cs-vid');
    if (!vid) return;

    /* Block xo-cart-add — we own this click completely */
    e.stopImmediatePropagation();
    btn.dataset.csBusy = '1';
    btn.classList.add('cs-pcard__atc-btn--loading');

    _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    }).then(function (res) {
      if (res.ok) {
        pushGA4AddToCart([{
          item_id: btn.dataset.csSku || '',
          item_name: btn.dataset.csTitle || '',
          price: parseFloat(btn.dataset.csPrice || 0) / 100,
          quantity: 1
        }]);
        showAtcToast();
        updateCartCount();
        refreshXoCartMini();
        openCartDrawer();
      }
      delete btn.dataset.csBusy;
      btn.classList.remove('cs-pcard__atc-btn--loading');
    }).catch(function () {
      delete btn.dataset.csBusy;
      btn.classList.remove('cs-pcard__atc-btn--loading');
    });
  }, true);

  /* ─── Fetch listener — covers PDP / Quick-View / any other xo-cart-add call ── */
  /* Note: product-card and modal use _fetch directly so they're handled above.   */
  /* xo-cart-add on PDP uses window.fetch, so this wrapper catches it here.       */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      p.then(function (res) {
        if (res.ok) {
          res.clone().json().then(function (data) {
            var items = Array.isArray(data.items) ? data.items : [data];
            pushGA4AddToCart(items.map(function (it, i) {
              return {
                item_id: it.sku || '',
                item_name: it.product_title || it.title || '',
                item_variant: it.variant_title || '',
                price: (it.price || 0) / 100,
                quantity: it.quantity || 1,
                index: i
              };
            }));
          }).catch(function () {});
          updateCartCount();
          refreshXoCartMini();
          openCartDrawer();
        }
        return res;
      }).catch(function () {});
    }
    return p; /* always return original promise so xo-cart-add can still read body */
  };

  /* ─── MutationObserver fallback — watches xo-cart-size badge ── */
  /* Fires toast when cart count increases (catches cases where XO bypasses our fetch wrapper) */
  function watchCartCount() {
    document.querySelectorAll('xo-cart-size').forEach(function (counter) {
      var last = parseInt(counter.textContent || '0', 10);
      new MutationObserver(function () {
        /* Only track the value — toast is handled by our ATC handler directly */
        last = parseInt(counter.textContent || '0', 10);
      }).observe(counter, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ─── XO cart event fallbacks (for any theme-initiated cart changes) ─── */
  ['cart:added', 'xo-cart:added', 'xo-cart-add:success', 'theme:cart:add'].forEach(function (evName) {
    document.addEventListener(evName, function () {
      showAtcToast();
      updateCartCount();
    });
  });

  /* ─── JudgeMe count format: ensure "(n)" in dynamic cards ─── */
  /* JudgeMe JS processes statically-rendered badges and adds "()" around the
     count. Cards inserted dynamically by xo-products-fetcher are not re-
     processed, so the raw badge shows "1" (no parens). This observer fixes
     any count element whose inner text is a plain number. */
  function fixJdgmCount(root) {
    (root || document).querySelectorAll('.jdgm-prev-badge__count').forEach(function (el) {
      var txt = el.textContent.trim();
      /* If it's already wrapped in parens, or empty, skip */
      if (!txt || txt.charAt(0) === '(') return;
      /* Only wrap plain numbers (e.g. "1", "12") */
      if (/^\d+$/.test(txt)) {
        el.textContent = '(' + txt + ')';
      }
    });
  }

  /* Run once on load, then watch for dynamically-added cards */
  var _jdgmObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('jdgm-prev-badge__count')) {
          fixJdgmCount(node.parentElement);
        } else if (node.querySelector) {
          fixJdgmCount(node);
        }
      });
    });
  });

  /* ─── Init ──────────────────────────────────────────── */
  function init() {
    initWishlistState();
    watchCartCount();
    /* Relocate + size upsell whenever user clicks the cart icon to open the drawer */
    document.addEventListener('click', function (e) {
      if (e.target.closest('xo-modal-trigger[xo-name="cart"]')) {
        setTimeout(function () { relocateCartUpsell(); sizeCartItems(); }, 350);
      }
    });
    fixJdgmCount();
    _jdgmObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* Re-apply wishlist state whenever coss-collection-sort.js swaps the grid */
  document.addEventListener('coss:grid:updated', initWishlistState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
